var _path, _circle, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 98,
    viewBox: "0 0 93 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0649 75.5026C59.9922 63.8975 68.2484 49.3766 68.2484 38.2746C68.2484 26.6898 59.0146 17.2984 47.6242 17.2984C36.2338 17.2984 27 26.6898 27 38.2746C27 49.3676 35.6898 63.874 46.214 75.4745C46.9763 76.3148 48.2871 76.3286 49.0649 75.5026ZM47.8005 49.5696C53.8364 49.5696 58.7295 44.5929 58.7295 38.454C58.7295 32.315 53.8364 27.3383 47.8005 27.3383C41.7645 27.3383 36.8714 32.315 36.8714 38.454C36.8714 44.5929 41.7645 49.5696 47.8005 49.5696Z",
    fill: "#404040"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.8429,
    cy: 46.8429,
    r: 40.8429,
    stroke: "#404040",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    width: 13,
    height: 5,
    transform: "rotate(90 50 0)",
    fill: "#F1F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 77.0572,
    width: 20,
    height: 5,
    transform: "rotate(90 50 77.0572)",
    fill: "#F1F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 15.9429,
    height: 5.31429,
    fill: "#F1F0F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0573,
    y: 44,
    width: 15.9429,
    height: 5.31429,
    fill: "#F1F0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.18ae046d.svg";
export { ForwardRef as ReactComponent };